import React from "react";
import "./GlobalWording.scss";

// Types
import { CurrentSegmentComponentProps } from "../SettingsTypes";

// Hooks
import { useTranslation } from "react-i18next";

// Components
import { IonLabel } from "@ionic/react";
import SubTitle from "../../../../components/Admin/Settings/SubTitle";
import { InputFactory } from "../../../../components/Factories/Input";

export default function GlobalWordingSegment(props: CurrentSegmentComponentProps) {
  const { t } = useTranslation();
  const { formData, updateFormData, errors, defaults } = props;

  const appNameField = React.useRef<HTMLInputElement>(null);
  const entityMembersField = React.useRef<HTMLInputElement>(null);
  const sectionChatField = React.useRef<HTMLInputElement>(null);
  const sectionLatestField = React.useRef<HTMLInputElement>(null);
  const sectionRegistrationField = React.useRef<HTMLInputElement>(null);
  const sectionRegisterField = React.useRef<HTMLInputElement>(null);
  const sectionDriveField = React.useRef<HTMLInputElement>(null);
  const sectionCalendarField = React.useRef<HTMLInputElement>(null);
  const miscProfileField = React.useRef<HTMLInputElement>(null);
  const miscPictureField = React.useRef<HTMLInputElement>(null);
  const miscAdminsField = React.useRef<HTMLInputElement>(null);
  const miscChannelField = React.useRef<HTMLInputElement>(null);

  return (
    <div className="page--admin--settings--global-wording">
      <p>{t("globalWordingSettingsTabExplainer")}</p>

      <SubTitle text={t("appName")} actionText={t("clearAll") as string} actionHandler={resetAppName} />
      <section>
        <div>
          <IonLabel>{t("default")}</IonLabel>
          <InputFactory type="text" className={"input__input input-factory__input input-factory__input--type-text"} placeholder={defaults.app_name} disabled />
        </div>

        <div>
          <IonLabel>{t("yourTerms")}</IonLabel>
          <InputFactory
            type="text"
            value={formData?.global_wording?.app_name}
            name="global_wording.app_name"
            onIonChange={updateFormData}
            className={"input__input input-factory__input input-factory__input--type-text"}
            error={errors?.global_wording?.app_name}
            inputRef={appNameField}
          />
        </div>
      </section>

      <SubTitle text={t("entityNames")} actionText={t("clearAll") as string} actionHandler={resetEntityNames} />
      <section>
        <div>
          <IonLabel>{t("default")}</IonLabel>
          <InputFactory type="text" className={"input__input input-factory__input input-factory__input--type-text"} placeholder={defaults.entity_members} disabled />
        </div>

        <div>
          <IonLabel>{t("yourTerms")}</IonLabel>
          <InputFactory
            type="text"
            value={formData?.global_wording?.entity_members}
            name="global_wording.entity_members"
            onIonChange={updateFormData}
            className={"input__input input-factory__input input-factory__input--type-text"}
            error={errors?.global_wording?.entity_members}
            inputRef={entityMembersField}
          />
        </div>
      </section>

      <SubTitle text={t("mainSectionNames")} actionText={t("clearAll") as string} actionHandler={resetMainSectionNames} />
      <section>
        <div>
          <IonLabel>{t("default")}</IonLabel>
          <InputFactory type="text" className={"input__input input-factory__input input-factory__input--type-text"} placeholder={defaults.section_chat} disabled />
          <InputFactory type="text" className={"input__input input-factory__input input-factory__input--type-text"} placeholder={defaults.section_latest} disabled />
          <InputFactory type="text" className={"input__input input-factory__input input-factory__input--type-text"} placeholder={defaults.section_calendar} disabled />
          <InputFactory type="text" className={"input__input input-factory__input input-factory__input--type-text"} placeholder={defaults.section_drive} disabled />
          <InputFactory type="text" className={"input__input input-factory__input input-factory__input--type-text"} placeholder={defaults.section_registration} disabled />
          <InputFactory type="text" className={"input__input input-factory__input input-factory__input--type-text"} placeholder={defaults.section_register} disabled />
        </div>

        <div>
          <IonLabel>{t("yourTerms")}</IonLabel>
          <InputFactory
            type="text"
            value={formData?.global_wording?.section_chat}
            name="global_wording.section_chat"
            onIonChange={updateFormData}
            className={"input__input input-factory__input input-factory__input--type-text"}
            error={errors?.global_wording?.section_chat}
            inputRef={sectionChatField}
          />

          <InputFactory
            type="text"
            value={formData?.global_wording?.section_latest}
            name="global_wording.section_latest"
            onIonChange={updateFormData}
            className={"input__input input-factory__input input-factory__input--type-text"}
            error={errors?.global_wording?.section_latest}
            inputRef={sectionLatestField}
          />

          <InputFactory
            type="text"
            value={formData?.global_wording?.section_calendar}
            name="global_wording.section_calendar"
            onIonChange={updateFormData}
            className={"input__input input-factory__input input-factory__input--type-text"}
            error={errors?.global_wording?.section_calendar}
            inputRef={sectionCalendarField}
          />

          <InputFactory
            type="text"
            value={formData?.global_wording?.section_drive}
            name="global_wording.section_drive"
            onIonChange={updateFormData}
            className={"input__input input-factory__input input-factory__input--type-text"}
            error={errors?.global_wording?.section_drive}
            inputRef={sectionDriveField}
          />

          <InputFactory
            type="text"
            value={formData?.global_wording?.section_registration}
            name="global_wording.section_registration"
            onIonChange={updateFormData}
            className={"input__input input-factory__input input-factory__input--type-text"}
            error={errors?.global_wording?.section_registration}
            inputRef={sectionRegistrationField}
          />

          <InputFactory
            type="text"
            value={formData?.global_wording?.section_register}
            name="global_wording.section_register"
            onIonChange={updateFormData}
            className={"input__input input-factory__input input-factory__input--type-text"}
            error={errors?.global_wording?.section_register}
            inputRef={sectionRegisterField}
          />
        </div>
      </section>

      <SubTitle text={t("misc")} actionText={t("clearAll") as string} actionHandler={resetMisc} />
      <section>
        <div>
          <IonLabel>{t("default")}</IonLabel>
          <InputFactory type="text" className={"input__input input-factory__input input-factory__input--type-text"} placeholder={defaults.misc_profile} disabled />
          <InputFactory type="text" className={"input__input input-factory__input input-factory__input--type-text"} placeholder={defaults.misc_picture} disabled />
          <InputFactory type="text" className={"input__input input-factory__input input-factory__input--type-text"} placeholder={defaults.misc_admins} disabled />
          <InputFactory type="text" className={"input__input input-factory__input input-factory__input--type-text"} placeholder={defaults.misc_channel} disabled />
        </div>

        <div>
          <IonLabel>{t("yourTerms")}</IonLabel>

          <InputFactory
            type="text"
            value={formData?.global_wording?.misc_profile}
            name="global_wording.misc_profile"
            onIonChange={updateFormData}
            className={"input__input input-factory__input input-factory__input--type-text"}
            error={errors?.global_wording?.misc_profile}
            inputRef={miscProfileField}
          />

          <InputFactory
            type="text"
            value={formData?.global_wording?.misc_picture}
            name="global_wording.misc_picture"
            onIonChange={updateFormData}
            className={"input__input input-factory__input input-factory__input--type-text"}
            error={errors?.global_wording?.misc_picture}
            inputRef={miscPictureField}
          />

          <InputFactory
            type="text"
            value={formData?.global_wording?.misc_admins}
            name="global_wording.misc_admins"
            onIonChange={updateFormData}
            className={"input__input input-factory__input input-factory__input--type-text"}
            error={errors?.global_wording?.misc_admins}
            inputRef={miscAdminsField}
          />

          <InputFactory
            type="text"
            value={formData?.global_wording?.misc_channel}
            name="global_wording.misc_channel"
            onIonChange={updateFormData}
            className={"input__input input-factory__input input-factory__input--type-text"}
            error={errors?.global_wording?.misc_channel}
            inputRef={miscChannelField}
          />
        </div>
      </section>
    </div>
  );

  function resetAppName() {
    updateFormData({
      detail: {
        name: "global_wording.app_name",
        value: null,
      },
    });

    if (appNameField.current) {
      appNameField.current.value = "";
    }
  }

  function resetEntityNames() {
    updateFormData({
      detail: {
        name: "global_wording.entity_members",
        value: null,
      },
    });

    if (entityMembersField.current) {
      entityMembersField.current.value = "";
    }
  }

  function resetMainSectionNames() {
    updateFormData({
      detail: {
        name: "global_wording.section_chat",
        value: null,
      },
    });
    updateFormData({
      detail: {
        name: "global_wording.section_latest",
        value: null,
      },
    });
    updateFormData({
      detail: {
        name: "global_wording.section_registration",
        value: null,
      },
    });
    updateFormData({
      detail: {
        name: "global_wording.section_register",
        value: null,
      },
    });
    updateFormData({
      detail: {
        name: "global_wording.section_drive",
        value: null,
      },
    });
    updateFormData({
      detail: {
        name: "global_wording.section_calendar",
        value: null,
      },
    });

    if (sectionChatField.current) {
      sectionChatField.current.value = "";
    }

    if (sectionLatestField.current) {
      sectionLatestField.current.value = "";
    }

    if (sectionRegistrationField.current) {
      sectionRegistrationField.current.value = "";
    }

    if (sectionRegisterField.current) {
      sectionRegisterField.current.value = "";
    }

    if (sectionDriveField.current) {
      sectionDriveField.current.value = "";
    }

    if (sectionCalendarField.current) {
      sectionCalendarField.current.value = "";
    }
  }

  function resetMisc() {
    updateFormData({
      detail: {
        name: "global_wording.misc_profile",
        value: null,
      },
    });
    updateFormData({
      detail: {
        name: "global_wording.misc_picture",
        value: null,
      },
    });
    updateFormData({
      detail: {
        name: "global_wording.misc_admins",
        value: null,
      },
    });
    updateFormData({
      detail: {
        name: "global_wording.misc_channel",
        value: null,
      },
    });

    if (miscProfileField.current) {
      miscProfileField.current.value = "";
    }

    if (miscPictureField.current) {
      miscPictureField.current.value = "";
    }

    if (miscAdminsField.current) {
      miscAdminsField.current.value = "";
    }

    if (miscChannelField.current) {
      miscChannelField.current.value = "";
    }
  }
}
